import React from 'react';
import { useQuery } from '@apollo/client';
import { Col, Row, Typography } from 'antd';
import { queries } from '../../../graphql/graphql';
import { ProposalCard } from '../../../components/Proposals/ProposalCard';
import type { Proposal } from '../../../types/proposal';
import { Loader } from '../../../components/UI/Loader';

const { Title, Paragraph } = Typography;

export const ContractorProposalsList: React.FC = () => {
  const { data, loading } = useQuery(queries.proposal.MY_PROPOSALS, {
    fetchPolicy: 'network-only'
  });

  if (loading) {
    return <Loader />;
  }

  const proposals: Proposal[] = data?.myProposals || [];

  return (
    <div style={{ width: '100%' }}>
      <Title level={3} style={{ marginBottom: 8 }}>
        Proposals
      </Title>
      <Paragraph type="secondary" style={{ marginTop: 0 }}>
        Review requests and update your pricing details.
      </Paragraph>
      {proposals.length ? (
        <Row gutter={[16, 16]} justify="start" >
          {proposals.map(proposal => (
            <Col key={proposal.id} xs={24} sm={24} md={12} lg={8} xl={8} xxl={6}>
              <ProposalCard
                proposal={proposal}
                viewPath={`/contractor/proposals/${proposal.id}`}
                editPath={`/contractor/proposals/${proposal.id}/edit`}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Paragraph>No proposals assigned yet.</Paragraph>
      )}
    </div>
  );
};
